import { Component, Inject } from '@angular/core';
import { NavItemService } from './services/nav-item.service';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { GEA_MES_NAVBAR_MENU_SERVICE, NavItem, GeaMesNavbarModule } from '@gea-mes/navbar';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import {​​​​ GeaMesCognitoAuthService }​​​​ from '@gea-mes/cognito';
import { Subscription} from 'rxjs';
import { appinfo } from './appinfo';

declare var gtag_setValue;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [GeaMesNavbarModule, RouterOutlet]
})
export class AppComponent {
  title = 'yamazumi-app';
  productionMode: boolean;
  trackingid:string;
  userTitle:string;
  userDivision:string;
  logon$: Subscription;
  standardworkUrl = '';

  constructor(
    private router: Router,
    private geaMesCognito: GeaMesCognitoAuthService,
    public navService:NavItemService,
    @Inject(GEA_MES_NAVBAR_MENU_SERVICE) private NavItem: BehaviorSubject<NavItem[]>    )
  {
    NavItem.next(navService.navItems);
    const navEndEvent$ = this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    );
    console.log("Version: ", appinfo.version)
  }
  ngOnInit(): void {
      gtag_setValue({"appversion": appinfo.version});

    this.logon$ = this.geaMesCognito.sessionEstablished$.subscribe( out => {
      this.trackingid = this.geaMesCognito.getUserAttribute("trackingid");
      this.userTitle = this.geaMesCognito.getUserAttribute("title");
      this.userDivision = this.geaMesCognito.getUserAttribute("division");
      if (this.trackingid != undefined) {
        gtag_setValue({"sub": this.trackingid});
        gtag_setValue({"title": this.userTitle});
        gtag_setValue({"division": this.userDivision});
        if (this.logon$) this.logon$.unsubscribe(); // We've done the work we need to, can unsubscribe
      }       
    });
    
    let origin = window.location.origin.replace('yamazumi', 'standardwork');
    if (window.location.hostname.toLowerCase() === 'localhost') {
      origin = 'https://standardwork-dev.sc.geappl.io';
    }
    this.standardworkUrl = `${origin}/teams`;  
  }


}